<p-button
  [label]="label"
  [icon]="icon"
  [iconPos]="iconPos"
  [disabled]="disabled"
  [styleClass]="styleClass"
  (onClick)="onButtonClick()"
>
</p-button>
